// extracted by mini-css-extract-plugin
module.exports = {"container":"container_ZB6k-","topMargin":"topMargin_1SBHp","message":"message_1ICu9","details":"details_20s-O","navigateButton":"navigateButton_2isI9"};